import React from 'react';
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillLinkedin,
  AiOutlineArrowUp,
} from 'react-icons/ai';

const Footer = () => {
  return (
    <footer>
      <div>
        <img
          src={'https://avatars.githubusercontent.com/u/88705142?v=4'}
          alt='Founder'
        />

        <h2>Sunil Kumar Yadav</h2>
        <p>Positive Attitude is the algorithm to solve unsorted life.</p>
      </div>

      <aside>
        <h2>Social Media</h2>

        <article>
          <a
            href='https://www.linkedin.com/in/sunil-kumar-yadav-a7ab43214/'
            target={'blank'}
          >
            <AiFillLinkedin />
          </a>

          <a href='https://github.com/sunielkumar' target={'blank'}>
            <AiFillGithub />
          </a>
          <a href='https://instagram.com/__suniel12?igshid=ZDdkNTZiNTM=' target={'blank'}>
            <AiFillInstagram />
          </a>
        </article>
      </aside>
      <a href='#home'>
        <AiOutlineArrowUp />
      </a>
    </footer>
  );
};

export default Footer;
